module.exports = __webpack_public_path__ + "static/media/Plus2Activity.a726b35e.mp3";